import React from 'react';
import Icons from '../../../Containers/Icons';

let SpecificTabUsrPer = (props) => {
  let {edit, view, id, changeUsrPer} = props;
  return (
    <div className="permissionsIcons">
      <span className={`viewPer ${view}`} onClick={() => changeUsrPer(id, "view")}>
        <Icons name="view"/>
      </span>
      <span className={`editPer ${edit}`} onClick={() => changeUsrPer(id, "edit")}>
        <Icons name="edit"/>
      </span>
    </div>
  )
}

export default SpecificTabUsrPer;


// WEBPACK FOOTER //
// ./src/Components/Admin/Tab/SpecificTabUsrPer.js